const rewriteImgUrls = (obj) => {
    if (!obj) return obj;
    if (typeof obj === 'string') {
        return obj.replace(/https?:\/\/img\d*\.24smi\.net\/[^\s"']+/g, (match) => {
            return `/api/ads/img?url=${encodeURIComponent(match)}`;
        });
    }
    if (Array.isArray(obj)) {
        return obj.map(item => rewriteImgUrls(item));
    }
    if (typeof obj === 'object') {
        const rewritten = {};
        for (const key in obj) {
            rewritten[key] = rewriteImgUrls(obj[key]);
        }
        return rewritten;
    }
    return obj;
};

export const fetchJsonAds = async (object, num, chash, show_id, utm_term) => {
    if (!object) {
        return { news: [], billingNoticeUrl: null };
    }
    try {
        let url = `/api/ads/rtb?object=${object}&output=json&num=${num}&chash=${chash}&show_id=${show_id}`;
        if (utm_term) {
            url += `&subid_source=${encodeURIComponent(utm_term)}`;
        }
        const response = await fetch(url);
        const data = await response.json();
        const rewrittenData = rewriteImgUrls(data);
        let billingNoticeUrl = rewrittenData.settings && rewrittenData.settings.billingNoticeUrl;
        if (billingNoticeUrl) {
            billingNoticeUrl = `/api/ads/forward?url=${encodeURIComponent(billingNoticeUrl)}`;
        }
        return {
            news: rewrittenData.news,
            billingNoticeUrl: billingNoticeUrl
        };
    } catch (error) {
        console.error('Error fetching the data:', error);
        return {
            news: [],
            billingNoticeUrl: null
        };
    }
}
